import React from 'react';
import PropTypes from 'prop-types';
import { generateImageSource } from '../../../utils/generateImageSource';
import './TableSortLabel.scss';

const CHEVRON_SVG = '/images/chevron-symbol.svg';

const ORDER = {
  ASC: 'asc',
  DESC: 'desc'
};

const chevronUpStyle = {
  width: '15px',
  transform: 'rotateZ(-90deg)'
};

const chevronDownStyle = {
  width: '15px',
  transform: 'rotateZ(90deg)'
};

const ChevronUp = () => {
  return (
    <img data-testid="chevron-up" src={generateImageSource(CHEVRON_SVG)} style={chevronUpStyle} />
  );
};

const ChevronDown = () => {
  return (
    <img
      data-testid="chevron-down"
      src={generateImageSource(CHEVRON_SVG)}
      style={chevronDownStyle}
    />
  );
};

const iconStyles = {
  display: 'flex',
  flexFlow: 'column',
  justifyContent: 'space-between',
  marginLeft: '10px'
  // position: 'absolute',
  // right: '0px',
  // top: '50%',
  // transform: 'translateY(-50%)'
};

const SortIcon = ({ order = null }) => {
  return (
    <div style={iconStyles}>
      {order !== ORDER.DESC && <ChevronUp />}
      {order !== ORDER.ASC && <ChevronDown />}
    </div>
  );
};

const TableSortLabel = ({ children, sort, field, handleSortChange }) => {
  const updateSort = () => {
    const calcOrder = (fieldType) => {
      if (fieldType === 'postedDate' || fieldType === 'applicantCount') {
        return ORDER.DESC;
      }
      return ORDER.ASC;
    };

    if (sort.by !== field) {
      handleSortChange({
        by: field,
        order: calcOrder(field)
      });
      return;
    }

    const next = { ...sort, order: sort.order === ORDER.ASC ? ORDER.DESC : ORDER.ASC };

    handleSortChange(next);
  };

  return (
    <span
      className="table-header-with-sort"
      onClick={updateSort}
      data-testid={`thead-sort-${field}`}
    >
      <div className="p2p-table__heading-text">{children}</div>
      {sort.by === field ? <SortIcon order={sort.order} /> : <SortIcon />}
    </span>
  );
};

TableSortLabel.propTypes = {
  sort: PropTypes.shape({
    by: PropTypes.string,
    order: PropTypes.string
  }),
  field: PropTypes.string,
  handleSortChange: PropTypes.func.isRequired
};

TableSortLabel.defaultProps = {
  sort: {
    by: '',
    order: ''
  },
  field: ''
};

export default TableSortLabel;
